// Gravity Forms 3 date picker (BRU-1091).
//
// Gravity Forms 3 replaced the jQuery UI datepicker with its own calendar,
// which by default opens only from the calendar icon button beside the field.
// The old one opened when the field was clicked or tabbed into, which is what
// customers are used to on the wholesale order and enquiry forms. The
// calendar library supports that natively (openOnFocus): it opens on focus,
// keeps the cursor in the field so a date can still be typed, and closes on
// Escape or when focus leaves. Gravity Forms passes its datepicker options
// through the gform_datepicker_options_pre_init filter.
//
// The old calendar also labelled the weekdays MO, TU, ...; Gravity Forms 3
// uses single letters, so those are restored too.
(function () {
  if (window.gform && typeof window.gform.addFilter === 'function') {
    window.gform.addFilter('gform_datepicker_options_pre_init', function (options) {
      options.openOnFocus = true;
      return options;
    });
  }

  function relabelWeekdays(root) {
    root.querySelectorAll('.gform-datepicker-calendar th.week[title] span').forEach(function (span) {
      var day = span.parentElement.getAttribute('title');
      if (day && span.textContent.trim().length < 2) {
        span.textContent = day.slice(0, 2);
      }
    });
  }

  // The calendar is (re)built when it opens and when the month changes.
  var observer = new MutationObserver(function () {
    relabelWeekdays(document);
  });

  function watchDateFields() {
    document.querySelectorAll('.ginput_container_date').forEach(function (container) {
      if (container.dataset.gfDatepickerWatched) {
        return;
      }
      container.dataset.gfDatepickerWatched = '1';
      observer.observe(container, { childList: true, subtree: true });
    });
  }

  document.addEventListener('DOMContentLoaded', watchDateFields);
  // Multi-page and AJAX forms re-render their fields.
  if (window.jQuery) {
    window.jQuery(document).on('gform_post_render', watchDateFields);
  }
})();
